import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
declare var google: any;

@Component({
  selector: "app-map-tracker",
  templateUrl: "./map-tracker.component.html",
  styleUrls: ["./map-tracker.component.css"],
})
export class MapTrackerComponent implements OnInit, OnChanges {
  @Output() truckTrackDtlsEvent = new EventEmitter<string>();
  @Output() WOTrackDetailsEvent = new EventEmitter<string>();
  marker: any;
  map: any;
  solidPolylines: any[] = [];
  dottedPolylines: any[] = [];
  @Input() startLoc: any;
  @Input() endLoc: any;
  @Input() curLoc: any;
  @Input() routeSegments: any;
  icon: any;
  isFirstLoad: boolean = true;
  aaa: any;
  tripsloading: boolean = false;
  constructor(
  ) { }

  ngOnInit(): void {
    this.initialize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes["curLoc"]) {
    if (this.curLoc && this.curLoc.length > 0) {
      this.navigateMaps();
    } else {
      // Center map to India and remove marker when curLoc is empty
      this.centerMapToIndia();
    }
    // }
  }

  radians_to_degrees(radians: any) {
    var pi = Math.PI;
    return radians * (180 / pi);
  }

  degrees_to_radians(degrees: any) {
    var pi = Math.PI;
    return degrees * (pi / 180);
  }

  headingAngleFromCoordinate(lat1: any, long1: any, lat2: any, long2: any) {
    const lat1Rad = this.degrees_to_radians(lat1);
    const lat2Rad = this.degrees_to_radians(lat2);
    const long1Rad = this.degrees_to_radians(long1);
    const long2Rad = this.degrees_to_radians(long2);

    let dLon = long2Rad - long1Rad;
    let y = Math.sin(dLon) * Math.cos(lat2Rad);
    let x =
      Math.cos(lat1Rad) * Math.sin(lat2Rad) -
      Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(dLon);
    let brng = Math.atan2(y, x);
    brng = this.radians_to_degrees(brng);
    brng = (brng + 360) % 360;

    return brng;
  }

  public navigateMaps() {
    if (!this.curLoc || this.curLoc.length === 0) return;

    // Update polyline
    this.updatePolyline();

    let prevPoint: any = null;
    let lastPoint: any = null;

    if (this.routeSegments && this.routeSegments.length > 0) {
      const validSegments = this.routeSegments.filter((seg: any) => seg && seg.length > 1);
      if (validSegments.length > 0) {
        const lastSeg = validSegments[validSegments.length - 1];
        const p1 = lastSeg[lastSeg.length - 2];
        const p2 = lastSeg[lastSeg.length - 1];
        prevPoint = { lat: Number(p1[1]), lng: Number(p1[0]) };
        lastPoint = { lat: Number(p2[1]), lng: Number(p2[0]) };
      }
    }

    if (!lastPoint && this.curLoc && this.curLoc.length >= 2) {
      const lastIndex = this.curLoc.length - 1;
      prevPoint = this.curLoc[lastIndex - 1];
      lastPoint = this.curLoc[lastIndex];
    }

    if (this.marker && prevPoint && lastPoint) {
      const heading = this.headingAngleFromCoordinate(
        Number(prevPoint.lat),
        Number(prevPoint.lng),
        Number(lastPoint.lat),
        Number(lastPoint.lng)
      );

      if (heading !== 0) {
        this.icon.rotation = heading;
        this.marker.setIcon(this.icon);
      }
    }
  }

  public initialize() {
    const initialLat = Number(this.curLoc?.lat || 20.5937);
    const initialLng = Number(this.curLoc?.lng || 78.9629);

    this.map = new google.maps.Map(document.getElementById("map_canvas"), {
      center: new google.maps.LatLng(initialLat, initialLng),
      zoom: this.curLoc && this.curLoc.length > 0 ? 3 : 7,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      minZoom: 2, // Set minimum zoom level
      maxZoom: 18,
    });

    // Zoom in and pan to the new position
    this.map.setZoom(6);
    // this.map.panTo(pos);

    if (this.curLoc) {
      var truck = ""; // Define your truck icon path here
      this.icon = {
        path: "M16.0227 5.68833L15.6477 5.44674V6.77548H14.375L14.625 4.77688L14.375 4.61216L20.5796 0.0109854L21.0227 0.351404L16.0227 5.68833ZM28.9659 0.340425L29.4205 0L35.625 4.60118L35.375 4.7659L35.625 6.7645H34.3523V5.43576L33.9773 5.68833L28.9659 0.340425ZM36.8296 61.2429H13.1705V40.3893H36.8296V61.2429ZM37.6364 7.1159C37.6364 7.85165 36.8864 8.45563 35.9546 8.45563H14.7273C13.8068 8.45563 13.0568 7.85165 13.0568 7.1159C13.0568 6.36917 13.8068 5.7652 14.7273 5.7652H35.9546C36.8864 5.7652 37.6364 6.36917 37.6364 7.1159ZM43.6364 28.8699H27.3068H24H6.89775C6.89775 28.8699 7.54547 13.8914 8.62502 12.2222C9.70456 10.5531 13.375 6.87432 15.3182 6.63273C16.7614 6.45703 22.6818 6.54488 25.625 6.59978C28.4545 6.54488 34.1364 6.45703 35.5341 6.63273C37.3978 6.87432 40.9318 10.5531 41.9659 12.2222C43.0114 13.8914 43.6364 28.8699 43.6364 28.8699V28.8699ZM25.2614 19.393L9.55683 18.9538C9.55683 18.9538 15 8.89488 16.4318 8.19208C17.8523 7.47829 25.2614 7.74184 25.2614 7.74184V19.393ZM25.2614 7.74184C25.2614 7.74184 32.6818 7.47829 34.1023 8.19208C35.5227 8.90586 40.9773 18.9538 40.9773 18.9538L25.2614 19.393V7.74184ZM41.1023 28.6283C41.1023 29.419 40.0568 30.0559 38.7728 30.0559H11.7614C10.4659 30.0559 9.43182 29.419 9.43182 28.6283V19.426C9.43182 18.6353 10.4659 17.9984 11.7614 17.9984H38.7728C40.0568 17.9984 41.1023 18.6353 41.1023 19.426V28.6283ZM39.75 29.7814C39.75 30.572 38.7728 31.2089 37.5796 31.2089H12.5C11.3068 31.2089 10.3296 30.572 10.3296 29.7814V20.568C10.3296 19.7884 11.3068 19.1405 12.5 19.1405H37.5796C38.7728 19.1405 39.75 19.7884 39.75 20.568V29.7814ZM43.6364 26.7615V45.5615H6.89775V26.7615H6.9091C7.21591 23.7087 15.3182 21.2599 25.2614 21.2599C35.2159 21.2599 43.3068 23.7087 43.625 26.7615H43.6364ZM12.5796 43.53H9.43182V27.1459C9.70455 24.4884 16.7273 22.347 25.3637 22.347C33.3978 22.347 40.0341 24.2029 41.1364 26.6078C38.2159 25.4328 33.6477 24.6751 28.5114 24.6751C19.875 24.6751 12.8523 26.8054 12.5909 29.4739H12.5796V43.53ZM35.6023 36.5349C35.6023 37.3255 34.5568 37.9625 33.2727 37.9625H20.0568C18.7614 37.9625 17.7159 37.3255 17.7159 36.5349V31.78C17.7159 30.9893 18.7614 30.3524 20.0568 30.3524H33.2727C34.5568 30.3524 35.6023 30.9893 35.6023 31.78V36.5349ZM35.6023 37.1828C35.6023 37.9734 34.5568 38.6104 33.2727 38.6104H20.0568C18.7614 38.6104 17.7159 37.9734 17.7159 37.1828V32.4279C17.7159 31.6372 18.7614 31.0003 20.0568 31.0003H33.2727C34.5568 31.0003 35.6023 31.6372 35.6023 32.4279V37.1828ZM9.51139 20.2606L6.20456 18.5804L0.170455 18.8769L0 18.218L6.53409 18.0423L10.2614 19.2942L9.51139 20.2606ZM39.7387 19.3052L43.4659 18.0423L50 18.218L49.8295 18.8879L43.7955 18.5804L40.4886 20.2606L39.7387 19.3052ZM47.2046 108.375C47.2046 109.275 46.4773 110 45.5796 110H4.39775C3.50002 110 2.77274 109.275 2.77274 108.375V48.7571C2.77274 47.8567 3.50002 47.1319 4.39775 47.1319H45.5796C46.4773 47.1319 47.2046 47.8567 47.2046 48.7571V108.375ZM47.2046 48.7571V108.375C47.2046 109.275 46.4773 110 45.5796 110H37.8409C38.7386 110 39.4659 109.275 39.4659 108.375V48.7571C39.4659 47.8567 38.7386 47.1319 37.8409 47.1319H45.5796C46.4773 47.1319 47.2046 47.8567 47.2046 48.7571ZM13.6591 110H9.14773V47.1319H13.6591V110ZM32.6705 77.3086C32.6705 81.4046 29.2273 84.732 24.9887 84.732C20.75 84.732 17.3182 81.4046 17.3182 77.3086C17.3182 73.2125 20.75 69.8962 24.9887 69.8962C29.2273 69.8962 32.6705 73.2125 32.6705 77.3086ZM31.5 77.3086C31.5 80.7787 28.5796 83.6009 24.9887 83.6009C21.3977 83.6009 18.4887 80.7787 18.4887 77.3086C18.4887 73.8385 21.3977 71.0273 24.9887 71.0273C28.5796 71.0273 31.5 73.8385 31.5 77.3086ZM22.5568 80.2296C22.5568 80.4492 22.3636 80.6359 22.1364 80.6359C21.8977 80.6359 21.7045 80.4492 21.7045 80.2296V74.3326C21.7045 74.102 21.8977 73.9153 22.1364 73.9153C22.3636 73.9153 22.5568 74.102 22.5568 74.3326V80.2296ZM28.2386 80.2296C28.2386 80.4492 28.0455 80.6359 27.8182 80.6359C27.5796 80.6359 27.3977 80.4492 27.3977 80.2296V74.3217C27.3977 74.102 27.5796 73.9153 27.8182 73.9153C28.0455 73.9153 28.2386 74.102 28.2386 74.3217V80.2296Z",
        scale: 0.3,
        strokeColor: "white",
        strokeWeight: 0.1,
        fillOpacity: 0.9,
        fillColor: "#f58634",
        offset: "5%",
        anchor: new google.maps.Point(10, 25),
        scaledSize: new google.maps.Size(30, 80),
      };

      this.marker = new google.maps.Marker({
        position: new google.maps.LatLng(
          Number(this.curLoc.lat),
          Number(this.curLoc.lng)
        ),
        icon: this.icon,
        map: this.map,
        title: "",
        zIndex:
          Math.round(
            new google.maps.LatLng(
              Number(this.curLoc.lat),
              Number(this.curLoc.lng)
            ).lat() * -100000
          ) << 5,
      });

      this.marker.addListener("click", (item: string) => {
        this.truckTrackDtlsEvent.emit(item);
      });

      this.navigateMaps();
    }
  }

  // Method to center the map to India
  centerMapToIndia() {
    const indiaCoordinates = { lat: 20.5937, lng: 78.9629 };

    if (this.map) {
      this.map.setCenter(indiaCoordinates);
      this.map.setZoom(2); // Adjust zoom level to show the full map of India
    }
    if (this.marker) {
      this.marker.setMap(null); // Remove the marker
      this.marker = null;
    }
  }

  // --- new changes --- //

  // Calculate distance between two points in meters
  private getDistanceBetweenPoints(
    lat1: number,
    lng1: number,
    lat2: number,
    lng2: number
  ) {
    const R = 6371e3; // Earth radius in meters
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lng2 - lng1) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distance in meters
  }

  private filterSpikes(path: any[]) {
    if (!path || path.length === 0) return [];
    const filteredPath = [path[0]];
    const tolerance = 10; // minimum distance in meters

    for (let i = 1; i < path.length; i++) {
      const location = path[i];
      const previousLocation = filteredPath[filteredPath.length - 1];

      const distance = this.getDistanceBetweenPoints(
        Number(previousLocation.lat),
        Number(previousLocation.lng),
        Number(location.lat),
        Number(location.lng)
      );

      // Filter out points that are too close
      if (distance < tolerance) {
        continue;
      }

      // Filter out spikes (unrealistically large jumps that jump back immediately)
      let isSpike = false;
      if (distance > 2000) { // 2km threshold for a potential spike
        if (i < path.length - 1) {
          const nextLocation = path[i + 1];
          const distanceNext = this.getDistanceBetweenPoints(
            Number(location.lat),
            Number(location.lng),
            Number(nextLocation.lat),
            Number(nextLocation.lng)
          );
          const distancePreviousToNext = this.getDistanceBetweenPoints(
            Number(previousLocation.lat),
            Number(previousLocation.lng),
            Number(nextLocation.lat),
            Number(nextLocation.lng)
          );

          // If the point shoots far away and the next point is much closer to the previous point
          // than it is to this current outlier point, it's a spike.
          if (distanceNext > 2000 && distancePreviousToNext < distance) {
            isSpike = true;
          }
        }
      }

      if (!isSpike) {
        filteredPath.push(location);
      }
    }
    return filteredPath;
  }

  updatePolyline() {
    if (!this.map || !this.curLoc || this.curLoc.length === 0) return;

    // Clear existing lines
    this.solidPolylines.forEach(p => p.setMap(null));
    this.dottedPolylines.forEach(p => p.setMap(null));
    this.solidPolylines = [];
    this.dottedPolylines = [];

    if (this.routeSegments && this.routeSegments.length > 0) {
      const validSegments = this.routeSegments.filter((seg: any) => seg && seg.length > 1);

      for (const segCoords of validSegments) {
        const path = segCoords.map((coord: any) => new google.maps.LatLng(Number(coord[1]), Number(coord[0])));
        this.solidPolylines.push(new google.maps.Polyline({
          path: path,
          strokeColor: "#f97316", // admin orange
          strokeWeight: 4,
          map: this.map
        }));
      }

      for (let i = 0; i < validSegments.length - 1; i++) {
        const from = validSegments[i][validSegments[i].length - 1];
        const to = validSegments[i + 1][0];
        const p1 = new google.maps.LatLng(Number(from[1]), Number(from[0]));
        const p2 = new google.maps.LatLng(Number(to[1]), Number(to[0]));
        this.dottedPolylines.push(new google.maps.Polyline({
          path: [p1, p2],
          strokeOpacity: 0,
          icons: [{
            icon: { path: 'M 0,-1 0,1', strokeOpacity: 1, scale: 2 },
            offset: '0',
            repeat: '10px'
          }],
          strokeColor: "#94a3b8", // gray
          map: this.map
        }));
      }
    } else {
      const filteredLocs = this.filterSpikes(this.curLoc);
      if (filteredLocs.length === 0) return;

      const GAP_MS = 5 * 60 * 1000;
      let seg = [filteredLocs[0]];

      for (let i = 1; i < filteredLocs.length; i++) {
        const time1 = new Date(filteredLocs[i - 1].trackDateTime).getTime();
        const time2 = new Date(filteredLocs[i].trackDateTime).getTime();
        const gap = (time1 && time2) ? (time2 - time1) : 0;

        if (gap > GAP_MS) {
          if (seg.length > 1) {
            const path = seg.map((p: any) => new google.maps.LatLng(Number(p.lat), Number(p.lng)));
            this.solidPolylines.push(new google.maps.Polyline({
              path: path,
              strokeColor: "#f97316", // admin orange
              strokeWeight: 4,
              map: this.map
            }));
          }

          // Add dotted line for the gap
          const p1 = new google.maps.LatLng(Number(filteredLocs[i - 1].lat), Number(filteredLocs[i - 1].lng));
          const p2 = new google.maps.LatLng(Number(filteredLocs[i].lat), Number(filteredLocs[i].lng));
          this.dottedPolylines.push(new google.maps.Polyline({
            path: [p1, p2],
            strokeOpacity: 0,
            icons: [{
              icon: { path: 'M 0,-1 0,1', strokeOpacity: 1, scale: 2 },
              offset: '0',
              repeat: '10px'
            }],
            strokeColor: "#94a3b8", // gray
            map: this.map
          }));

          seg = [filteredLocs[i]];
        } else {
          seg.push(filteredLocs[i]);
        }
      }

      if (seg.length > 1) {
        const path = seg.map((p: any) => new google.maps.LatLng(Number(p.lat), Number(p.lng)));
        this.solidPolylines.push(new google.maps.Polyline({
          path: path,
          strokeColor: "#f97316",
          strokeWeight: 4,
          map: this.map
        }));
      }
    }

    // Move marker to the latest point
    if (this.curLoc.length > 0) {
      const lastPoint = this.curLoc[this.curLoc.length - 1];
      this.setMarker({ lat: Number(lastPoint.lat), lng: Number(lastPoint.lng) });

      // Only panTo and setZoom on the initial load to prevent "jumping"
      if (this.isFirstLoad) {
        this.map.panTo(new google.maps.LatLng(Number(lastPoint.lat), Number(lastPoint.lng)));
        this.map.setZoom(16);
        this.isFirstLoad = false;
      }
    }
  }

  // Method to set the marker at a specific location
  private setMarker(position: { lat: number; lng: number }) {
    if (this.marker) {
      this.marker.setPosition(
        new google.maps.LatLng(position.lat, position.lng)
      );
    } else {
      this.marker = new google.maps.Marker({
        position: new google.maps.LatLng(position.lat, position.lng),
        icon: this.icon,
        map: this.map,
        title: "",
      });

      this.marker.addListener("click", (item: string) => {
        this.truckTrackDtlsEvent.emit(item);
      });
    }
  }
}
